<template>
  <div class="verify">
    <div class="banner-guide">
      <div class="banner-text">{{ rewardName ? $t('bannerText', {reward: rewardName}) : $t('bannerTextNoReward') }}</div>
      <img class="banner-gift" src="@/assets/image/verify/banner-gift.png">
    </div>
    <div class="ktp-upload-area">
      <div class="ktp-display">
        <img v-if="frontImageUrl" :src="frontImageUrl" class="ktp-img">
        <img v-else src="@/assets/image/verify/bg-ktp-sample.png" class="ktp-img">
      </div>
      <div class="image-tip" :class="{ 'normal':!hasKtpError, 'rejected': hasKtpError }">
        <md-icon name="info" size="sm" class="icon"></md-icon>
        {{ noticeMessage }}
      </div>
      <div class="btn-submit">
        <md-image-reader
          name="frontImageReader"
          @select="onReaderSelect"
          @complete="onReaderComplete"
          @error="onReaderError"
          size="5000"
          :mime="mimeType"
        ></md-image-reader>
        <md-button class="" type="primary" round @click.prevent="validateForm">
          {{ $t('uploadKTP') }}
        </md-button>
      </div>
    </div>
    <div class="ktp-sample">
      <div class="sample-title">
        {{ $t('ktpSampleTitle') }}
      </div>
      <div class="sample-desc">
        {{ $t('ktpSampleDesc') }}
      </div>
      <div class="sample-img">
        <img src="@/assets/image/verify/ktp-sample.png">
      </div>
    </div>
    <div class="split-block"></div>
    <div class="contact-us">
      <div class="contact-title">{{ $t('contactTitle') }}</div>
      <div class="contact-item">
        <div class="label">{{ $t('phoneLabel') }}</div>
        <div class="value">
          <a class="link" href="tel:081324887208">081324887208</a>
        </div>
      </div>
      <div class="contact-item">
        <div class="label">{{ $t('emailLabel') }}</div>
        <div class="value">
          <a class="link" href="mailto:pendanaan@kreditpintar.com">pendanaan@kreditpintar.com</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, ImageReader } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        bannerText: 'Complete onboarding process to get {reward}. Takes 1 mins',
        bannerTextNoReward: 'Complete onboarding process. Takes 1 mins',
        uploadKTP: 'Upload e-KTP',
        imageTip: 'Photo must be larger than 256 x 256 Pixel and size must be smaller than 5 Mb in JPG/JPEG/PNG format',
        ktpNotExist: 'Please upload KTP',
        verifyRejectedTip: 'Your application was rejected，please make sure your KTP is correct!',
        ktpSampleTitle: 'KTP Photo Example',
        ktpSampleDesc: 'Please upload the correct ID information, otherwise it will affect your information review.',
        contactTitle: 'If you don\'t have e-KTP, please contact us:',
        phoneLabel: 'Telephone',
        emailLabel: 'E-mail',
      },
      id: {
        bannerText: 'Verifikasi data Anda, dapatkan {reward}. Hanya butuh 1 menit',
        bannerTextNoReward: 'Verifikasi data Anda. Hanya butuh 1 menit',
        uploadKTP: 'Unggah e-KTP',
        imageTip: 'Foto harus berukuran lebih besar dari 256 x 256 Pixel dan Ukuran harus lebih kecil dari 5 Mb dalam format JPG/JPEG/PNG',
        ktpNotExist: 'Silahkan unggah KTP',
        verifyRejectedTip: 'Permintaan Anda ditolak, pastikan KTP Anda betul!',
        ktpSampleTitle: 'Contoh Foto KTP',
        ktpSampleDesc: 'Harap mengunggah informasi ID yang benar karena akan mempengaruhi audit.',
        contactTitle: 'Jika Anda tidak memiliki e-KTP, silahkan menghubungi:',
        phoneLabel: 'Telepon',
        emailLabel: 'E-mail',
      },
    },
  },
  components: {
    [ImageReader.name]: ImageReader,
    [Button.name]: Button,
  },
  data() {
    const info = this.$store.state.userInfo
    const isWeixin = window.navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1
    return {
      rewardName: '',
      infoForm: {
        frontImage: info.status === 'INITIAL' ? '' : info.frontImage,
      },
      frontImageUrl: '',
      noticeMessage: info.status === 'REJECTED' ? this.$t('verifyRejectedTip') : this.$t('imageTip'),
      hasKtpError: info.status === 'REJECTED',
      mimeType: isWeixin ? '*' : ['jpeg', 'png'],
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    verifyRejected() {
      return this.userInfo.status === 'REJECTED'
    },
  },
  async mounted() {
    if (this.infoForm.frontImage) {
      this.getImage(this.infoForm.frontImage)
    }
    if (['INITIAL', 'REJECTED'].includes(this.userInfo.status)) {
      await this.getActivityName()
    }
  },
  methods: {
    async getActivityName() {
      try {
        const channel = this.userInfo.channel || 'default'
        const response = await this.$http.get(`/marketing/channel?code=${channel}`)
        const data = response.data.data
        this.rewardName = data && data.eventActivityMappings ? data.eventActivityMappings.find(i => i.event === 'KYC').activityName[this.$i18n.locale] || '' : ''
      } catch (error) {
        console.log(error)
      }
    },
    async getImage(image) {
      if (image) {
        try {
          const params = {
            fileName: image,
          }
          const response = await this.$http.get('/file/url/ktp', { params })
          this.frontImageUrl = response.data.data
        } catch (error) {
          console.error(error)
        }
      }
    },
    onReaderSelect(name, { files }) {
      this.$toast.loading('loading...')
    },
    async onReaderComplete(name, { dataUrl, file }) {
      await this.uploadImage({ file: file })
      this.$toast.hide()
    },
    onReaderError(name, { msg }) {
      this.$toast.failed(msg)
    },
    async uploadImage(data) {
      try {
        const formData = new FormData()
        formData.append('file', data.file)
        this.$toast.loading('loading...')
        const response = await this.$http.post('/file/upload/ktp', formData)
        this.$toast.hide()
        const [imageName] = Object.keys(response.data.data)
        this.infoForm.frontImage = imageName
        const [imageUrl] = Object.values(response.data.data)
        this.frontImageUrl = imageUrl

        // 提交KTP
        this.submitForm()
      } catch (error) {
        console.log(error)
      } finally {
        this.$toast.hide()
      }
    },
    async submitForm() {
      // 没有上传图片或上传后未能识别出nik和name,提示上传ktp，不可提交
      if (!this.frontImageUrl) {
        this.hasKtpError = true
        this.noticeMessage = this.$t('ktpNotExist')
        return
      }
      try {
        if (window.bridge && window.bridge.afTrackEvent) {
          window.bridge.afTrackEvent('kyc', '')
        }
        const kycPayload = {
          ktpFileName: this.infoForm.frontImage,
        }
        this.$toast.loading('loading...')
        const response = await this.$http.post('/investor/update-kyc', kycPayload)
        const code = response.data.code

        // 认证成功，跳转到认证成功页面
        switch (code) {
          case 'SUCCESS':
            if (window.bridge && window.bridge.afTrackEvent) {
              window.bridge.afTrackEvent('kyc succeed', '')
            }
            this.$router.push({ name: 'SignupResult' })
            break
          case 'KTP_FILE_NOT_EXIST':
            this.hasKtpError = true
            this.noticeMessage = this.$t('ktpNotExist')
            break
          case 'KTP_OCR_FAILED':
            this.hasKtpError = true
            this.noticeMessage = this.$t('verifyRejectedTip')
            break
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.$toast.hide()
      }
    },
    switchRoute(name) {
      this.$router.push({ name: name })
    },
  },
}
</script>

<style lang="stylus" scoped>
.verify {
  padding-bottom: 30px;
}

.banner-guide {
  padding: 6px 12px 6px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  background: linear-gradient(135deg, rgba(255, 172, 0, 1) 0%, rgba(255, 92, 0, 1) 100%);
  .banner-text {
    font-size: 15px;
    font-weight: bold;
    font-style: italic;
    line-height: 18px;
    text-shadow: 0 1px 2px rgba(179, 0, 0, 0.5);
    margin-right: 16px;
  }
  .banner-gift {
    width: 91px;
    height: 58px;
  }
}

.ktp-upload-area {
  background-color: #fff;
  padding: 30px 0;
  .ktp-display {
    padding: 0 52px;
    margin: 0 auto;
    .ktp-img {
      width: 100%;
      height: 100%;
    }
  }
  .image-tip {
    margin: 18px 36px 28px;
    font-size: 10px;
    font-weight: bold;
    line-height: 14px;
    display: flex;
    justify-content: flex-start;
    &.normal {
      color: #878B99;
    }
    &.rejected {
      color: #FF3B53;
    }
    .icon {
      font-size: 10px;
      margin-right: 10px;
    }
  }
  .btn-submit /deep/ {
    position: relative;
    margin: 0 52px;
    height: 40px;
    .md-button {
      line-height: 20px;
    }
  }
}

.ktp-sample {
  background-color: #fff;
  padding: 0 57px 18px;
  text-align: center;
  .sample-title {
    font-size: 14px;
    font-weight: bold;
    color: #999;
    line-height: 12px;
  }
  .sample-desc {
    font-size: 11px;
    color: #888;
    line-height: 13px;
    margin: 10px 0 20px;
  }
  .sample-img {
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.contact-us {
  background-color: #fff;
  margin-top: 6px;
  padding: 24px;
  .contact-title {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 16px;
  }
  .contact-item {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    line-height: 32px;
    .value {
      font-weight: bold;
      .link {
        color: inherit;
        font-weight: bold;
      }
    }
  }
}
</style>
